<script setup lang="ts">
import type { MorningApplication } from '~~/shared/types/morning'
import { lucideIconComponents } from '~/utils/lucideIcons'

const props = defineProps<{
  application: Pick<MorningApplication, 'name' | 'icon'>
}>()

const failed = ref(false)

const initials = computed(() =>
  props.application.name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toLocaleUpperCase() ?? '')
    .join(''),
)

const imageSource = computed(() => {
  const icon = props.application.icon
  return icon && ['image', 'url'].includes(icon.type) ? icon.value : undefined
})
</script>

<template>
  <span
    class="application-icon"
    :class="`icon-${application.icon?.type ?? 'fallback'}`"
    aria-hidden="true"
  >
    <img
      v-if="imageSource && !failed"
      :src="imageSource"
      alt=""
      loading="lazy"
      @error="failed = true"
    />
    <span
      v-else-if="application.icon?.type === 'emoji'"
      class="icon-emoji"
      >{{ application.icon.value }}</span
    >
    <component
      :is="lucideIconComponents[application.icon.value]"
      v-else-if="application.icon?.type === 'lucide'"
      :size="27"
      :stroke-width="1.75"
    />
    <span
      v-else
      class="icon-initials"
      >{{ initials }}</span
    >
  </span>
</template>
